import { Stack } from 'expo-router';
import { ScrollView } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/UI/Box';
import EventShareStatsWidget from './components/EventShareStatsWidget';

export default function EventShareStats() {
  return (
    <ScrollView contentContainerStyle={style.scrollView}>
      <Stack.Screen options={{ title: 'Stats Share' }} />
      <Box space="lg" p="lg" alignItems="center">
        <EventShareStatsWidget />
      </Box>
    </ScrollView>
  );
}

const style = StyleSheet.create((_, rt) => ({
  scrollView: {
    paddingBottom: rt.insets.bottom,
  },
}));
